module.exports = __webpack_public_path__ + "img/horneadas2.9181e0e7.jpeg";